import { render, staticRenderFns } from "./MspApproval.vue?vue&type=template&id=4738dd78&scoped=true"
import script from "./MspApproval.vue?vue&type=script&lang=js"
export * from "./MspApproval.vue?vue&type=script&lang=js"
import style0 from "./MspApproval.vue?vue&type=style&index=0&id=4738dd78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4738dd78",
  null
  
)

export default component.exports